import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../ThemeContext';
import './Navbar.css';

const NAV_LINKS = [
  { to: '/',              label: 'Home',          icon: '⌨' },
  { to: '/mouse-tester',  label: 'Mouse Test',    icon: '🖱' },
  { to: '/about',         label: 'About',         icon: 'ℹ' },
  { to: '/contact',       label: 'Contact',       icon: '✉' },
  { to: '/privacy-policy',label: 'Privacy',       icon: '🔒' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { theme, toggle } = useTheme();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    document.body.style.overflow = '';
  }, [location]);

  const toggleMenu = () => {
    setMenuOpen(o => {
      document.body.style.overflow = !o ? 'hidden' : '';
      return !o;
    });
  };

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-inner">
          <Link to="/" className="nav-logo">
            <span className="logo-icon">⌨</span>
            <span>Key<span className="accent">Test</span></span>
          </Link>

          <div className="nav-right">
            {/* Desktop links */}
            <ul className="nav-links">
              {NAV_LINKS.map(l => (
                <li key={l.to}>
                  <Link to={l.to} className={location.pathname === l.to ? 'active' : ''}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>

            <button className="theme-toggle" onClick={toggle}
              aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
              title={theme === 'dark' ? 'Light Mode' : 'Dark Mode'}>
              {theme === 'dark' ? (
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="5"/>
                  <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
                  <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                  <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
                  <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                </svg>
              ) : (
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                </svg>
              )}
            </button>

            <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
              <span className={menuOpen ? 'open' : ''} />
              <span className={menuOpen ? 'open' : ''} />
              <span className={menuOpen ? 'open' : ''} />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile full-screen menu */}
      <div className={`mobile-menu ${menuOpen ? 'open' : ''}`} role="navigation">
        {NAV_LINKS.map((l, i) => (
          <React.Fragment key={l.to}>
            {i === 2 && <div className="mobile-divider" />}
            <Link to={l.to} className={location.pathname === l.to ? 'active' : ''}>
              <span className="mobile-menu-icon">{l.icon}</span>
              {l.label}
            </Link>
          </React.Fragment>
        ))}
      </div>
    </>
  );
}
